import React from "react";
import { IMAGE_BASE_URL } from "../data/baseURL";

const ColocationSection = ({ solution_colocation }) => {
  return (
    <section className="row pt-7 pb-7" id="colocation">
      <div
        className="col-12 col-md-4"
        data-aos="fade-right"
        data-aos-duration="3000"
      >
        <img
          src={`${IMAGE_BASE_URL}/${solution_colocation?.image}`}
          loading="lazy"
          alt=""
          className="img-fluid d-block mb-4"
        />
      </div>
      <div
        className="col-12 col-md-8"
        data-aos="fade-left"
        data-aos-duration="3000"
      >
        <h3 className="fs-30 lh-40 mb-4">Colocation</h3>
        <p
          className="fs-18"
          dangerouslySetInnerHTML={{ __html: solution_colocation?.description }}
        />
      </div>
    </section>
  );
};
export default ColocationSection;
